import React from 'react';

export const AuthContext = React.createContext(null);

export function useAuth() {
  return React.useContext(AuthContext);
}

export const KEY_AUTHENTICATED_USER = 'key-instantread-pms-authenticated-user';

/** The signed-in user is kept in localStorage so a refresh, a new tab or a browser restart keep the session (the JWT itself expires server-side). */
function readStoredUser() {
  try {
    const store = localStorage.getItem(KEY_AUTHENTICATED_USER) || sessionStorage.getItem(KEY_AUTHENTICATED_USER);
    return store ? JSON.parse(store) : null;
  } catch (e) {
    return null;
  }
}

export default class AuthProvider extends React.Component {
  constructor(props) {
    super(props);
    // Restored synchronously, so the very first render already knows the user: an async restore in
    // componentDidMount let RequireAuth redirect a refreshed page to the login screen first.
    this.state = { user: readStoredUser() };
    this.signIn = this.signIn.bind(this);
    this.signOut = this.signOut.bind(this);
  }

  signIn(user) {
    this.setState({ user }, function () {
      try {
        localStorage.setItem(KEY_AUTHENTICATED_USER, JSON.stringify(user));
        sessionStorage.removeItem(KEY_AUTHENTICATED_USER);
      } catch (e) {
        /* storage unavailable */
      }
    });
  }

  signOut() {
    this.setState({ user: null }, function () {
      try {
        localStorage.removeItem(KEY_AUTHENTICATED_USER);
        sessionStorage.removeItem(KEY_AUTHENTICATED_USER);
      } catch (e) {
        /* storage unavailable */
      }
    });
  }

  render() {
    return (
      <AuthContext.Provider value={{ user: this.state.user, signIn: this.signIn, signOut: this.signOut }}>
        {this.props.children}
      </AuthContext.Provider>
    );
  }
}
